/* @flow */

export enum HttpMethod {
  DELETE,
  GET,
  PATCH,
  POST,
  PUT,
}
